import { atom } from 'recoil'

export const drinkState = atom({
    key: 'drink',
    default: {level: 98, name: 'Water'}, 
  });